import { Listbox, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { ChevronDownIcon } from "../../../assets/icons/icon-chevron-down";

export const Dropdown = ({
  options,
  onClickItem,
  placeholder = "카테고리 선택",
  width = "w-56",
  height = "h-8",
  border = "border border-button-grey",
  textColor = "text-secondary-grey",
  dropdownWidth = "w-full",
  // placeholderColor = "text-secondary-grey",
  defaultValue,
  positionDropdown,
  backgroundDropdown,
  iconColor,
  display = "block",
  position = "absolute",
  marginTop = "-mt-2",
  isRightAlignment = false,
  rightAlignment = "justify-end mr-[1.5rem]",
  isResetted,
}) => {
  const defaultCat = options?.find((val) => val.id === defaultValue)?.name;
  const [selected, setSelected] = useState(defaultValue ? defaultCat : options);

  return (
    <Listbox
      defaultValue={defaultValue}
      value={selected}
      onChange={setSelected}
    >
      <div className={`relative ${display}`}>
        <Listbox.Button
          className={`${width} ${height} ${textColor} ${border} ${backgroundDropdown} rounded-[4px] p-[6px]`}
        >
          <span
            className={`flex truncate text-left ${
              typeof selected === "string" ? "text-black" : ""
            } ${isRightAlignment ? rightAlignment : ""}`}
          >
            {typeof selected === "string" ? selected : placeholder}
          </span>
          <span
            className={`${iconColor} pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2`}
          >
            <ChevronDownIcon className="w-4 h-4" />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options
            className={`z-50 ${position} ${marginTop} max-h-60 ${dropdownWidth} ${positionDropdown} overflow-auto bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm`}
          >
            {options?.map((val, idx) => (
              <Listbox.Option
                key={idx}
                className={({ active }) =>
                  `relative cursor-default select-none py-0.5 pl-4 pr-4 ${
                    active ? "bg-amber-100 text-amber-900" : "text-gray-900"
                  }`
                }
                value={val?.name}
                onClick={() => onClickItem(val?.id)}
              >
                {({ selected }) => (
                  <>
                    <span
                      className={`block truncate text-[12px] ${
                        selected ? "font-medium" : "font-normal"
                      }`}
                    >
                      {val?.name}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                        {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};
